/**
 * Simply return the serialized data
 */
export default {
  methods: {
    async submitAction(data) {
      return data
    },
  },
}